import { Button } from "@mui/material"
import { AuthoringSelectorActions } from "authoring/plugins/schedule-migration/authoring-selector-actions"
import { AuthoringScheduleSelectorDialog } from "authoring/plugins/schedule-migration/authoring-schedule-selector-dialog"
import { updateProjectGroup } from "authoring/routes/project/group/controller/update-project-group"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useDialog } from "lib/@hooks/useDialog"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import Iconify from "minimals-template/components/Iconify"
import { useParams } from "react-router"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"

const AUTHORING_SCHEDULES = "authoring schedules"

export function AddLeadingSummarySchedulesButton({ variant = "text" }) {
    const { project, projectGroup } = useBoundContext()
    const { projectId, groupId } = useParams()
    const existingSchedules = projectGroup?.leadingSummaryTypeSchedules ?? []
    const existingSelectionIds = existingSchedules?.map((s) => s?.id) ?? []

    const selectorDialog = useDialog(
        <AuthoringScheduleSelectorDialog
            type={AUTHORING_SCHEDULES}
            allowMultiple={true}
            actionsComponent={AuthoringSelectorActions}
            existingSelection={existingSelectionIds}
            primarySx={{ width: 650, maxWidth: 650 }}
        />,
        { maxWidth: "lg" }
    )
    return (
        <Button
            variant={variant}
            onClick={handleClick}
            startIcon={<Iconify icon="ic:round-post-add" />}
            data-cy="add-leading-summary-schedules-button"
            disabled={projectGroup?.readOnly || isLockedToLegacy(project?.phase) || !!project?.archived}
        >
            Add Schedules
        </Button>
    )

    async function handleClick() {
        try {
            const selectSchedules = await selectorDialog()
            if (selectSchedules) {
                const leadingSummaryTypeSchedules = selectSchedules?.map(({ id, code, title }) => ({
                    id,
                    code,
                    title,
                }))
                const added = await updateProjectGroup({
                    projectId,
                    group: { id: groupId, leadingSummaryTypeSchedules },
                })
                if (added) {
                    successSnackbar(`${leadingSummaryTypeSchedules.length} Schedules added successfully`)
                } else {
                    errorSnackbar("Failed to add Schedules")
                }
            }
        } catch (e) {
            console.error(e)
            errorSnackbar("Failed to add Schedules")
        }
    }
}
